import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { UserState, LayoutProps, SpendingReportState } from '../interface/MyInterfaces';
import { EmployeeReportState } from '../interface/EmployeeReportInterface';
import { VendorReportState } from '../interface/VendorReportInterface';
import { CTSAReportState } from '../interface/CTSAReportInterface';
import NewSpendingReportButton from './NewSpendingReportButton';
import { downloadPDFReport, downloadReport } from '../actions/SpendingReportActions';
import { downloadNewVendorReportData } from '../actions/VendorReportActions';
import { downloadCTSAData } from '../actions/CTSAReportActions';
import { clearSharedLink } from '../actions/UserActions';

import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';
import { bindActionCreators } from 'redux';

import SharedLinkForm from './Reports/SharedLinkForm';
import styled from "styled-components";

import html2canvas from "html2canvas";

import { saveAs } from 'file-saver';
import { isAgg } from './common/Helpers';
interface ReportLayoutProps {
    UserState?: UserState;
    SpendingReportState?: SpendingReportState;
    CTSAReportState?:CTSAReportState;
    EmployeeReportState?: EmployeeReportState;
    VendorReportState?: VendorReportState;
    //downloadReport(SpendingReportState, FilterState);
    downloadReport?:any;
    //downloadCTSAData(CTSAReportState);
    downloadCTSAData?:any;
    downloadNewVendorReportData?: any;
    downloadPDFReport?(activeTabIndex, reportType);
    clearSharedLink?();
}

interface ReportLayoutState {
    currentDateTime?: any;
    showModal?: any;
    activeTabIndex: number;
    downloadWasCalled?: boolean;
    tabsPrinted?: number;
    spendingDataAllLoaded?: boolean;
}

const DownloadButton = styled.button`
    color:#fff;
    cursor:pointer;
    font-size:18px;
    background-color: transparent;
    border: none;
    &:disabled{
        color: #d9d9d9;
    }
`;

class BenchmarkingLayout extends React.Component<LayoutProps & RouteComponentProps<{}>, {}> {
    constructor(props) {
        super(props);
        //let now: Date = new Date();
        //var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();
        //this.state = { showModal: false, activeTabIndex: 0, currentDateTime: currentDate, downloadWasCalled: false, tabsPrinted: 0, spendingDataAllLoaded: false };
        //this.handleOpenSharedLink = this.handleOpenSharedLink.bind(this);
        //this.handleDownloadFiles = this.handleDownloadFiles.bind(this);
        //this.closeShareWindow = this.closeShareWindow.bind(this);
        //this.handleDownloadPDF = this.handleDownloadPDF.bind(this);
        //this.saveImage = this.saveImage.bind(this);
        //this.savePDF = this.savePDF.bind(this);
    }


    //handleTabClickFromParent = (activeTabIndex) => {
    //    this.setState({
    //        activeTabIndex: activeTabIndex
    //    });
     
        
    //}

    renderChildrenWithProps() {
        return React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child as React.ReactElement<any>, {
                //handleTabClickFromParent: this.handleTabClickFromParent,
                //tabIsActive: this.tabIsActive,
                //doneUpdatingTab: this.doneUpdatingTab
            });
        });
    }

    public render() {
        const irislogo = require('../images/IRISLogoW.png');
        const download = require('../images/download.png');
        const share = require('../images/share.png');

        var notShared = true;
        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        if (sharedLinkPageOnLoad) {
            notShared = false;
        }
        var report_type = this.props.match.path.split('/')[2];
        return <div className="reportLayout" style={{ opacity: sharedLinkPageOnLoad && this.props.UserState.sharedLinkEmailSubmitted===false ? 0 : 1}}>
            <div className='content'>
                <div className="topBackdrop"></div>
                <div className='all'>
                    {this.renderChildrenWithProps()}
                </div>
            </div>
        </div>;
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            downloadReport: downloadReport,
            clearSharedLink: clearSharedLink,
            downloadPDFReport: downloadPDFReport,
            downloadCTSAData,
            downloadNewVendorReportData
        }, dispatch
    )
}
          
const mapStateToProps = (state: ApplicationState) => ({
    FilterState: state.filterProperties,
    SpendingReportState: state.spendingReportProperties,
    EmployeeReportState: state.employeeReportProperties,
    UserState: state.userProperties,
    CTSAReportState: state.CTSAReportProperties,
    VendorReportState: state.vendorReportProperties
});


export default connect(
    mapStateToProps,
    matchDispatchToProps)(BenchmarkingLayout);


